/**
 * ReportDetails screen styles - V3 Design
 */

import { StyleSheet, Dimensions } from 'react-native'
import { heightPercentageToDP as hp, widthPercentageToDP as wp } from 'react-native-responsive-screen';

import AppStyles from '../../AppStyles';

const screenWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
  // V3: Section card container - matches Submit Report card styling
  sectionCard: {
    backgroundColor: AppStyles.colorSet.cardBackground,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: AppStyles.colorSet.cardBorder,
    padding: 20,
    marginTop: hp(2),
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
  },
  // V3: Card title - matches Submit Report cardTitle
  cardTitle: {
    marginBottom: 12,
  },
  // V3: Subsection heading within cards (e.g., "Hazard Type", "Location")
  subsectionHeading: {
    marginTop: hp(1.5),
    marginBottom: hp(0.5),
  },
  // V3: First subsection (no top margin needed)
  subsectionHeadingFirst: {
    marginBottom: hp(0.5),
  },
  // V3: Empty state text
  emptyText: {
    textAlign: 'left',
    marginTop: hp(0.5),
  },
  // V3: Report ID footer - subtle, not in card
  reportIdContainer: {
    marginTop: hp(3),
    marginBottom: hp(2),
    paddingTop: hp(2),
    borderTopWidth: 1,
    borderTopColor: '#E5E5E5',
  },
  reportIdLabel: {
    marginBottom: 4,
  },
  // V3: Clean container for UUID display
  orangeContainer2: {
    borderRadius: 12,
    backgroundColor: AppStyles.colorSet.inputBackground,
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: wp(3.2),
    marginTop: hp(1),
    maxHeight: hp(40),
    borderColor: AppStyles.colorSet.cardBorder,
    borderWidth: 1,
  },
  // Legacy: Section headings (kept for compatibility)
  heading: {
    marginTop: hp(2),
    marginBottom: hp(0.5),
  },
});

export default styles;
